import { request } from 'react-common'

type CreateSelfEnrollmentModel = {
  id?: string
  objectiveAccessId: string
}

export class CreateSelfEnrollmentsApi {
  private static readonly api = request('create-self-enrollments/:id?')

  static create(body: CreateSelfEnrollmentModel) {
    return this.api.post({
      body,
      headers: {
        prefer: 'respond-sync',
      },
    })
  }
}
